import Router from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getUserMe } from '../redux/user/actions';
import Layout from '../layout/Layout';
import Sidebar from '../components/user/Sidebar';

import FeedEvents from '../components/events/FeedEvents';
import { getUserEvents, setFocusedEvent } from '../redux/events/actions';

import withAuth from '../hoc/withAuth';
import Button from '../components/buttons/Button';

const ITEMS_PER_PAGE = 2;

const Intranet = () => {
  const user = useSelector((state) => state.user);
  const { total, events } = useSelector((state) => state.events);
  const isUserLoading = useSelector((state) => state.user.isIntranetLoading);
  const isPendingEvents = useSelector((state) => state.events.isLoadingEvents);
  const [page, setPage] = useState(1);

  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      if (!user.id) {
        await dispatch(getUserMe());
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (user?.id && user.intranetAccess === false) {
        Router.push('/confirm-user');
      }

      if (user?.id) {
        await dispatch(
          getUserEvents({ userId: user.id, limit: ITEMS_PER_PAGE, page })
        );
      }
    })();
  }, [user]);

  const handlePagination = async (p) => {
    setPage(p);
    await dispatch(
      getUserEvents({ userId: user.id, limit: ITEMS_PER_PAGE, page: p })
    );
  };

  const handleEventClick = async (event) => {
    await dispatch(setFocusedEvent(event));
  };

  return (
    <Layout
      link="salir"
      className=""
      isLoading={isUserLoading || isPendingEvents}>
      <div className="c-intranet">
        <Sidebar user={user} />
        <div className="c-intranet__feed">
          <div className="c-intranet__header">
            <h2>Tus eventos o actividades publicadas</h2>
            <Button isActive href="/new-event">
              Nuevo Evento
            </Button>
          </div>
          {events && (
            <FeedEvents
              isIntranet
              onEventClick={handleEventClick}
              events={events}
              page={page}
              count={Math.ceil(total / ITEMS_PER_PAGE)}
              onChange={(e, p) => handlePagination(p)}
              noResultsMessages={{
                title: 'Todavía no tienes ningún evento',
                subtitle: '¡Comienza ahora! Haz click en nuevo evento',
                body: 'Puedes publicar tu evento en unos pocos clicks y reunir toda la información sobre tu evento en un solo lugar. ¡Aps, esperamos que sea todo un éxito!',
              }}
            />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default withAuth(Intranet);
